export enum SupportedPlugin {
  Incident = 'grafana-incident-app',
  OnCall = 'grafana-oncall-app',
  Irm = 'grafana-irm-app',
  MachineLearning = 'grafana-ml-app',
  Labels = 'grafana-labels-app',
  Slo = 'grafana-slo-app',
  Assistant = 'grafana-assistant-app',
}
